import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Star, Trash2, Copy, Archive } from "lucide-react";
import { useTr } from "@/i18n/translator";

export default function ContentBank() {
  const tr = useTr();
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = () => api.get("/bank").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const toggleFav = async (item) => {
    await api.patch(`/bank/${item.id}`, { ...item, is_favorite: !item.is_favorite });
    load();
  };
  const remove = async (id) => {
    await api.delete(`/bank/${id}`);
    toast.success("Eliminado");
    load();
  };
  const copy = (text) => { navigator.clipboard.writeText(text); toast.success("Copiado"); };

  const filtered = items.filter((i) => {
    if (filter === "all") return true;
    if (filter === "fav") return i.is_favorite;
    return i.network === filter;
  });

  return (
    <div className="space-y-6" data-testid="bank-page">
      <div>
        <div className="font-mono-mark text-[10px] text-[#5C5C5C]">{tr("RESERVA · CONTENIDO EVERGREEN")}</div>
        <h1 className="font-display text-4xl sm:text-5xl mt-2">{tr("Banco de contenido")}</h1>
      </div>

      <div className="flex flex-wrap gap-2">
        {["all", "fav", "twitter", "facebook", "instagram", "linkedin", "tiktok"].map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            className={`font-mono-mark text-[10px] px-3 py-2 border ${filter === f ? "bg-[#0A0A0A] text-white border-[#0A0A0A]" : "bg-white border-[#0A0A0A]"}`}
            data-testid={`bank-filter-${f}`}
          >
            {f === "all" ? tr("TODOS") : f === "fav" ? tr("FAVORITOS") : f.toUpperCase()}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="bg-white border border-dashed border-[#0A0A0A] p-10 text-center">
          <Archive className="w-8 h-8 mx-auto text-[#5C5C5C]" />
          <div className="font-mono-mark text-[10px] text-[#5C5C5C] mt-3">{tr("SIN ITEMS")}</div>
          <div className="text-sm mt-1">{tr("Guarda posts desde el Generador para reutilizarlos.")}</div>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((i) => (
            <div key={i.id} className="bg-white border border-[#0A0A0A] p-5 flex flex-col" data-testid={`bank-item-${i.id}`}>
              <div className="flex items-center justify-between mb-2">
                <span className="font-mono-mark text-[10px] text-[#E53935]">{i.network.toUpperCase()}</span>
                <button onClick={() => toggleFav(i)} data-testid={`bank-fav-${i.id}`}>
                  <Star className={`w-4 h-4 ${i.is_favorite ? "fill-[#FFD600] text-[#0A0A0A]" : "text-[#5C5C5C]"}`} />
                </button>
              </div>
              <div className="font-display text-lg leading-tight mb-2 line-clamp-2">{i.title}</div>
              <p className="text-sm flex-1 line-clamp-5 whitespace-pre-wrap">{i.body}</p>
              {i.hashtags?.length > 0 && (
                <div className="mt-2 font-mono-data text-xs text-[#E53935] line-clamp-1">{i.hashtags.join(" ")}</div>
              )}
              <div className="flex gap-2 mt-4 pt-4 border-t border-[#0A0A0A]">
                <button onClick={() => copy(i.body)} className="font-mono-mark text-[9px] px-2 py-1 border border-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white flex items-center gap-1">
                  <Copy className="w-3 h-3" /> {tr("COPIAR")}
                </button>
                <button onClick={() => remove(i.id)} className="font-mono-mark text-[9px] px-2 py-1 border border-[#E53935] text-[#E53935] hover:bg-[#E53935] hover:text-white flex items-center gap-1" data-testid={`bank-delete-${i.id}`}>
                  <Trash2 className="w-3 h-3" /> {tr("ELIMINAR")}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
